export default __webpack_public_path__ + "static/networks-d0bc272bfba5a56a5202c62e2cca2ff8.webp";